module.exports = __webpack_public_path__ + "media/Main-Page-Clarity.641c88c0.mp4";